import React from 'react'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'
import { Link } from 'react-router-dom'

const CardTitle = ({ title, href, TaggingClick }) => {
  const titleProductDesktop = title && title.trim().length > 60
    ? title.trim().substr(0, 60) + '...'
    : title.trim()
  const titleProductMobile = title && title.trim().length > 60
    ? title.trim().substr(0, 40) + '...'
    : title.trim()

  return title && (
    <div className='card-name col-12 mt-0 p-0'>
      <MediaQuery minWidth={1025}>
        <Link aria-label={titleProductDesktop} className='h3 box-card-link d-block txt-body-sm color-ui-2 txt-font-body txt-left' to={href || '/search'} onClick={() => TaggingClick()}>
          { titleProductDesktop }
        </Link>
      </MediaQuery>
      <MediaQuery maxWidth={1024}>
        <Link aria-label={titleProductMobile} className='h3 box-card-link d-block txt-body-sm color-ui-2 txt-font-body txt-left' to={href || '/search'} onClick={() => TaggingClick()}>
          { titleProductMobile }
        </Link>
      </MediaQuery>
    </div>
  )
}

CardTitle.propTypes = {
  title: PropTypes.string.isRequired,
  TaggingClick: PropTypes.func,
  href: PropTypes.string
}

export default CardTitle



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductCard/CardTitle/index.js